import { useEffect, useState } from 'react';
import useAxios from '../../../axios/useAxios';
import wrongStorePikko from '../../../styles/img/icons/wrong-store-icon.svg';
import askPikko from '../../../styles/img/logo/ask-pikko.svg';

import { useSelector } from 'react-redux';

import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { isOlderThanFiveMinutes } from '../../../utils/date-helper';

import { PERMISSION_DENIED, PERMISSION_GRANTED } from '../constant';
import { requestGeolocation } from '../utils';
import { CardStore } from './CardStore';
import { GeolocationWrapModal } from './GeolocationWrapModal';

export const GeolocationWrongStoreModal = ({ setCode, setProduct }) => {
  const axiosInstance = useAxios();

  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);

  const [stores, setStores] = useState([]);

  const [, setIsCheckStore] = useLocalStorage('isCheckStore');
  const [storeLocal, ] = useLocalStorage('store');
  const [isCheckStoreAlreadyAsk, setIsCheckStoreAlreadyAsk] = useLocalStorage('isCheckStoreAlreadyAsk');

  const [geolocationPermission,] = useLocalStorage('geolocationPermission');
  const [geolocationPositionResult, setGeolocationPositionResult] = useLocalStorage('geolocationPositionResult');
  const [geolocationPermissionLastDemand, setGeolocationPermissionLastDemand] = useLocalStorage('geolocationPermissionLastDemand');

  const { store } = useSelector((state) => state.store);
  const { cartItems } = useSelector((state) => state.cart);

  const geolocationPermissionLastDemandDate = JSON.parse(geolocationPermissionLastDemand)

  const messageWrongSelectedStore = 'Oups, tu n’es pas dans le magasin sélectionné.';
  const messageAskAndCheckStore = 'Es-tu dans le bon magasin ?';

  function setIsCheckStoreVerif () {
    if (!isCheckStoreAlreadyAsk) {
      setIsCheckStore('true');
    }
  }

  function closeAndShowCheckStore () {
    setIsCheckStoreVerif();
    setIsOpen(false);
  }

  function closeModal () {
    setTimeout(() => {
      setIsOpen(false);
    }, 4000);
  }

  async function managePositionResult (resultGeolocation) {
    if (resultGeolocation.status !== 'success') {
      setError("Une erreur inconnue s'est produite");
      setIsCheckStoreVerif();
      closeModal();
    } else {
      setGeolocationPositionResult(JSON.stringify(resultGeolocation));
      setGeolocationPermissionLastDemand(JSON.stringify(new Date()));

      const { longitude, latitude } = resultGeolocation;
      const urlLocation = `/store/nearby?longitude=${longitude}&latitude=${latitude}`;
      const resultStoresNearby = await axiosInstance.get(urlLocation);

      console.info('managePositionResult', resultStoresNearby)
      return resultStoresNearby.data;
    }
  }

  function checkIsWrongStore (resultStores) {
    const storeFromLocalStorage = JSON.parse(storeLocal)?.store

    console.info('checkIsWrongStore resultStores', resultStores)
    console.info('checkIsWrongStore store redux', store)
    console.info('checkIsWrongStore store localStorage', storeFromLocalStorage)

    if (resultStores.length === 1 && resultStores[0]._id === storeFromLocalStorage?.id)
      setIsOpen(false)
    else {
      console.info({isCheckStoreAlreadyAsk})
      if (!isCheckStoreAlreadyAsk) {
        setStores(resultStores)
        setIsOpen(true)
      }
    }
  }

  useEffect(() => {
    async function retrieveNearbyStores () {
      try {
        let resultGeolocation
        if (geolocationPermission === PERMISSION_GRANTED &&
            geolocationPositionResult &&
            !isOlderThanFiveMinutes(geolocationPermissionLastDemandDate)) {
          resultGeolocation = JSON.parse(geolocationPositionResult)
        }
        else {
          resultGeolocation = await requestGeolocation();
        }

        console.info('retrieveNearbyStores', resultGeolocation)
        return await managePositionResult(resultGeolocation)
      } catch (error) {
        console.error('retrieveNearbyStores', error);

        setError(error.message);
        setIsCheckStoreVerif();
        closeModal();
      }
    };

    async function checkLocalGeolocation () {
      console.info('checkLocalGeolocation Scan geolocationPermission', geolocationPermission)
      setIsCheckStore(null);

      if (geolocationPermission === PERMISSION_DENIED) {
        closeAndShowCheckStore()
      }
      else if (geolocationPermission) {
        const resultStores = await retrieveNearbyStores()
        console.info('checkLocalGeolocation Scan resultStores', resultStores)

        if (!resultStores || resultStores.length === 0) {
          closeAndShowCheckStore()
        }
        else {
          checkIsWrongStore(resultStores)
        }
      }
      else if (geolocationPermissionLastDemandDate) {
        setIsOpen(false);
        setIsCheckStore('true');
      }
      else return
    }

    checkLocalGeolocation()
  }, [geolocationPermission, geolocationPositionResult, storeLocal]);

  const handleClose = () => {
    setIsOpen(false);
    setIsCheckStore(null);
    setIsCheckStoreAlreadyAsk('true');
  };

  return (
    <GeolocationWrapModal image={stores.length === 1 ? wrongStorePikko : askPikko} isOpen={isOpen}>
      <h1 className="text-2xl text-center mt-6 mb-2 text-red-500">
        {stores.length === 1 ? messageWrongSelectedStore : messageAskAndCheckStore}
      </h1>

      {error ? (
        <p className="text-base text-red-500 text-center mb-6 geomanistRegular">{error}</p>
      ) : (
        <div className="text-xl text-gray-500 text-center mb-6 geomanistRegular">
          <p>Voici les magasins à proximité :</p>
        </div>
      )}

      <div className="h-1 w-[110%]"
           style={{ borderTop: "1px solid #e1e3e8", borderTopStyle: "thin" }}/>

      <div className="h-[250px] overflow-auto w-full">
        {stores.map(store => {
          return (
            <CardStore
              orderId={cartItems._id}
              key={store._id}
              title={store.name}
              description={store.address}
              image={store.logo}
              storeId={store._id}
              setCode={setCode}
              setProduct={setProduct}
              setIsOpen={setIsOpen}
            />
          );
        })}
      </div>

      <div className="h-1 w-[110%]"
           style={{ borderTop: "1px solid #e1e3e8", borderTopStyle: "thin" }}/>

      <div className="mt-5 flex flex-col gap-4 justify-center items-center w-full">
        <button type="button"
                className="border border-gray-200 w-full py-6 font-bold text-2xl rounded-lg"
                onClick={handleClose}>
          {"Je suis dans le bon magasin"}
        </button>
      </div>
    </GeolocationWrapModal>
  );
};
